import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    Input,
} from '@angular/core';
import { EnvironmentService } from 'providers/environment.service';
import { TimeDisplayService } from 'shared/time-display-service/time-display.service';

@Component({
    selector: 'ce-time-display',
    templateUrl: './time-display.component.html',
    styleUrls: ['./time-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeDisplayComponent {
    @Input() @HostBinding('class') public themeClass: 'theme-mykempower' | 'theme-chargeye' = 'theme-chargeye';

    showMenu = false;

    timeObservable$ = this.timeDisplayService.timeObservable$;

    constructor(
        private timeDisplayService: TimeDisplayService,
        private eRef: ElementRef,
        private cdRef: ChangeDetectorRef,
        private environmentService: EnvironmentService
    ) {
        this.environmentService.getAppOrigin$().subscribe((origin) => {
            this.themeClass = `theme-${origin}`;
            this.cdRef.markForCheck();
        });
    }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        // Hide time display menu if clicked outside of it
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showMenu = false;
        }
    }
}
